import { render, staticRenderFns } from "./u-chip-outlined-label.vue?vue&type=template&id=1a41a8cc&scoped=true"
import script from "./u-chip-outlined-label.vue?vue&type=script&lang=js"
export * from "./u-chip-outlined-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41a8cc",
  null
  
)

export default component.exports